import { render, staticRenderFns } from "./expediente.vue?vue&type=template&id=32e45906&scoped=true"
import script from "./expediente.vue?vue&type=script&lang=js"
export * from "./expediente.vue?vue&type=script&lang=js"
import style0 from "./expediente.vue?vue&type=style&index=0&id=32e45906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e45906",
  null
  
)

export default component.exports